export default __webpack_public_path__ + "47d1a21b4297e62f49af375302accb9c.svg";